import { Stripe, StripeElements } from "@stripe/stripe-js";
import { connect } from "react-redux";

import {
  subscriptionUpdateErrored,
  subscriptionUpdateErrorMessage
} from "seneca-common/features/subscriptions/state";
import { analyticsLogUpdatePaymentMethod } from "seneca-common/features/subscriptions/state/analytics";

import { handleUpdatePaymentMethodFormSubmit } from "features/subscriptions/features/stripe/actions/handleUpdatePaymentMethodFormSubmit";

type OwnProps = {
  subscriptionId: string;
  stripe: Stripe;
  stripeElements: StripeElements;
  postcode: string;
  errorMessage: string | null | undefined;
  stripeErrorMessage: string | null | undefined;
  onSuccess: (() => void) | null | undefined;
  onSubmitError: (() => void) | null | undefined;
  onSubmitFailure: () => void;
};

type StateProps = {
  errorMessage: string | null | undefined;
};

type DispatchProps = {
  onCreditCardFormSubmit: (cardHolderEmail?: string) => Promise<void>;
};

export type InjectedProps = DispatchProps;

const mapStateToProps = (
  state: any,
  { errorMessage, stripeErrorMessage, subscriptionId }: OwnProps
): StateProps => {
  return {
    errorMessage:
      errorMessage ||
      stripeErrorMessage ||
      (subscriptionUpdateErrored(state, subscriptionId)
        ? subscriptionUpdateErrorMessage(state, subscriptionId)
        : null)
  };
};

const mapDispatchToProps = (
  dispatch: any,
  {
    stripe,
    stripeElements,
    onSubmitFailure,
    onSuccess,
    subscriptionId
  }: OwnProps
): DispatchProps => ({
  onCreditCardFormSubmit: async (
    cardHolderEmail?: string,
    postcode?: string
  ) => {
    await dispatch(
      handleUpdatePaymentMethodFormSubmit(
        subscriptionId,
        cardHolderEmail,
        postcode,
        {
          stripe,
          stripeElements,
          onSubmitFailure,
          onSuccess: () => {
            analyticsLogUpdatePaymentMethod();
            onSuccess && onSuccess();
          }
        }
      )
    );
  }
});

const withHandleUpdatePaymentMethodFormSubmit = connect(
  mapStateToProps,
  mapDispatchToProps
);

export { withHandleUpdatePaymentMethodFormSubmit };
